/* eslint-disable import/first */
import React from 'react';
import { Favourite as FavouriteIcon } from '../Icons';
import { FavouriteFilled as FavouriteFilledIcon } from '../Icons';

import css from './index.module.scss';

export default function FavouriteBar({ isFavourite, onToggle, tags }) {
  return (
    <div className={css.favouriteBar}>
      <div className={css.CategoryTagsBar}>
        {tags.map((tag) => (
          <img src={tag?.product_asset} alt={tag?.tagName} />
        ))}
      </div>
      <span className={css.favIcon} onClick={onToggle}>
        {isFavourite === -1 ? <FavouriteIcon /> : <FavouriteFilledIcon />}
      </span>
    </div>
  );
}
